import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import WheelIcon from 'shared/icons/wheel.svg'

import s from './styles.module.scss'

interface Props {
  countSeat: number
}

export const SchemeHeader = ({ countSeat }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <img
        src={WheelIcon}
        className={s.icon}
      />

      <div className={clsx('regular-14', s.countSeat)}>
        {t('beket.seat_free_scheme')}

        <span className={clsx('semi-bold-14', s.count)}>{countSeat}</span>
      </div>
    </div>
  )
}
